import React from 'react';
import { EditDatastream } from '../../EditDatastream';

const getDefaultEditorDatastream = (id) => ({
  id,
  max: 0,
  min: 0,
  pin: '',
  name: '',
  sync: false,
  unit: '',
  alias: '',
  color: 'rgb(0, 0, 0)',
  isRow: false,
  action: false,
  reports: false,
  thenSet: 'no thing',
  dataType: 'String',
  decimals: '',
  condition: false,
  invalidate: false,
  customChart: false,
  defaultValue: 0,
  enableHistory: false,
  automationType: '',
  invalidateUnit: 'sec',
  invalidateValue: 0
});

const WidgetDatastreamEditor = ({
  addDatastream,
  setAddDatastream,
  datastreams,
  setDatastreams,
  validDatastreams,
  getNextDatastreamId,
  templateEvaluationData,
  setTemplateEvaluationData,
}) => {
  if (!addDatastream.edit) {
    return null;
  }

  return (
    <EditDatastream
      state={{ ...addDatastream, mode: 'edit' }}
      setState={setAddDatastream}
      datastream={getDefaultEditorDatastream(getNextDatastreamId(validDatastreams))}
      setDatastream={(newDatastream) => setDatastreams(datastreams ? [...datastreams, newDatastream] : [newDatastream])}
      templateDatastreams={validDatastreams}
      templateEvaluationData={templateEvaluationData}
      setTemplateEvaluationData={setTemplateEvaluationData}
    />
  );
};

export default WidgetDatastreamEditor;
